export default {
    // Header Section
    "discover_your": "अपनी खोजें",
    "love_report": "प्रेम रिपोर्ट",
    "cosmic_love_insights": "ब्रह्मांडीय प्रेम अंतर्दृष्टि",
    "love_report_description": "वैदिक ज्योतिष पर आधारित व्यापक प्रेम और रिश्ते के विश्लेषण के साथ अपने रोमांटिक भाग्य के रहस्यों को खोलें। अनुकूलता, विवाह का समय, आत्मा साथी की विशेषताओं और स्थायी प्रेम के लिए व्यक्तिगत मार्गदर्शन की अंतर्दृष्टि प्राप्त करें।",

    // Service Information
    "enter_details_for_love_analysis": "प्रेम विश्लेषण के लिए अपना विवरण दर्ज करें",
    "complete_love_analysis": "संपूर्ण प्रेम विश्लेषण",
    "service_price": "सेवा मूल्य",
    "comprehensive_love_analysis_note": "आपकी रोमांटिक क्षमता और रिश्ते की अनुकूलता का गहरा विश्लेषण",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_love_vibration": "आपका नाम आपकी रोमांटिक तरंगों और आकर्षण पैटर्न को प्रभावित करता है",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "अपना फोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "स्त्री",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_love_compatibility": "आपके प्रेम और अनुकूलता पैटर्न निर्धारित करने के लिए आवश्यक",
    "time_of_birth": "जन्म समय",
    "exact_time_critical_for_love": "सटीक शुक्र और सप्तम भाव गणना के लिए सटीक समय आवश्यक",
    "place_of_birth": "जन्म स्थान",
    "place_of_birth_placeholder": "शहर, राज्य, देश",
    "location_essential_for_love": "स्थान प्रेम और रिश्तों को प्रभावित करने वाली ग्रहों की स्थिति को प्रभावित करता है",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेजी",
    "hindi": "हिंदी",
    "telugu": "तेलुगू",
    "kannada": "कन्नड़",
    "language_note": "आपका प्रेम विश्लेषण चुनी गई भाषा में प्रदान किया जाएगा",

    // Core Love Features
    "love_compatibility_analysis": "आपका प्रेम जीवन विश्लेषण",
    "relationship_potential_insights": "रिश्ते की संभावना अंतर्दृष्टि",
    "marriage_timing_predictions": "विवाह समय भविष्यवाणी",
    "soulmate_identification": "आत्मा साथी की पहचान",
    "romantic_guidance_tips": "रोमांटिक मार्गदर्शन सुझाव",
    "pdf_download": "व्यापक पीडीएफ रिपोर्ट",

    "what_you_get": "आपके प्रेम विश्लेषण में क्या शामिल है",
    "comprehensive_love_chart": "व्यापक प्रेम चार्ट",
    "romantic_compatibility_score": "रोमांटिक अनुकूलता स्कोर",
    "relationship_guidance": "रिश्ते का मार्गदर्शन",
    "marriage_timing_insights": "विवाह समय अंतर्दृष्टि",

    // Actions & Buttons
    "pay_and_generate_analysis_love": "मेरा प्रेम विश्लेषण प्राप्त करें",
    "processing_payment": "भुगतान प्रसंस्करण",
    "processing_request": "विश्लेषण तैयार की जा रही है",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "love_analysis_processing": "आपका प्रेम विश्लेषण हमारे विशेषज्ञ रिश्ता ज्योतिषियों द्वारा तैयार किया जा रहा है। आपको अपने रोमांटिक भाग्य और अनुकूलता पैटर्न में विस्तृत अंतर्दृष्टि प्राप्त होगी।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान की गई राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "विश्लेषण डिलीवरी",
    "within_12_hours_delivery_note_love": "आपकी विस्तृत प्रेम रिपोर्ट 24 घंटों के भीतर तैयार हो जाएगी",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "पूरा विश्लेषण इस पर भेजा गया",

    // What You'll Receive
    "what_youll_receive": "आपका प्रेम विश्लेषण पैकेज",
    "detailed_love_report": "व्यापक प्रेम रिपोर्ट (पीडीएफ)",
    "compatibility_analysis_detailed": "विस्तृत अनुकूलता विश्लेषण",
    "relationship_timing_predictions": "रिश्ते के समय की भविष्यवाणी",
    "soulmate_characteristics": "आत्मा साथी विशेषताएं प्रोफाइल",
    "romantic_enhancement_tips": "रोमांटिक वृद्धि सुझाव",

    // Visual Content
    "sample_love_analysis": "नमूना प्रेम विश्लेषण",
    "love_compatibility_score": "आपका प्रेम जीवन स्कोर",
    "sample_love_reading": "गहरे भावनात्मक संबंध के साथ उच्च रोमांटिक क्षमता",
    "sample_love_preview": "अनुकूलता अंतर्दृष्टि के साथ आपके व्यक्तिगत प्रेम विश्लेषण का पूर्वावलोकन",
    "love_analysis_categories": "प्रेम विश्लेषण श्रेणियां",

    // Love Category Types
    "compatibility": "अनुकूलता",
    "romance": "रोमांस",
    "marriage": "विवाह",
    "soulmate": "आत्मा साथी",
    "attraction": "आकर्षण",
    "passion": "जुनून",

    // Status & Processing
    "your_love_analysis_status": "आपके प्रेम विश्लेषण की स्थिति",
    "processing_your_analysis": "आपके प्रेम पैटर्न का विश्लेषण",
    "analysis_processing_message": "हमारे रिश्ता ज्योतिष विशेषज्ञ आपकी रोमांटिक अनुकूलता और प्रेम भाग्य निर्धारित करने के लिए आपकी शुक्र स्थिति और सप्तम भाव का अध्ययन कर रहे हैं।",
    "request_id": "विश्लेषण आईडी",
    "status": "स्थिति",
    "processing": "प्रगति में",
    "pending": "कतार में",
    "email_notification_sent": "पुष्टिकरण ईमेल भेजा गया",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट सक्षम",
    "delivery_within_12_hours": "रिपोर्ट 12 घंटों के भीतर तैयार",

    // Support & Contact
    "contact_support": "प्रेम सहायता से संपर्क करें",
    "need_help": "मार्गदर्शन चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक जन्म विवरण पूरा करें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "विश्लेषण प्रसंस्करण असफल। हमारी सहायता टीम से संपर्क करें।",

    // Love-Specific Elements
    "seventh_house": "सप्तम भाव (विवाह भाव)",
    "venus_position": "शुक्र स्थिति और प्रभाव",
    "mars_influence": "मंगल और जुनून संकेतक",
    "moon_emotions": "चंद्रमा और भावनात्मक अनुकूलता",
    "jupiter_blessings": "प्रेम में बृहस्पति का आशीर्वाद",
    "love_yogas": "प्रेम और विवाह योग",

    // Compatibility Analysis
    "zodiac_compatibility": "राशि अनुकूलता",
    "nakshatra_matching": "नक्षत्र अनुकूलता",
    "guna_milan": "गुण मिलान विश्लेषण",
    "doshas_matching": "दोष अनुकूलता जांच",
    "planetary_harmony": "ग्रहों का सामंजस्य स्कोर",
    "elemental_compatibility": "तत्व अनुकूलता",

    // Love Personality Analysis
    "romantic_nature": "रोमांटिक प्रकृति और शैली",
    "love_language": "आपकी प्रेम भाषा",
    "emotional_needs": "रिश्तों में भावनात्मक आवश्यकताएं",
    "attraction_patterns": "आकर्षण पैटर्न",
    "relationship_approach": "रिश्ते का दृष्टिकोण शैली",
    "commitment_style": "प्रतिबद्धता और निष्ठा शैली",

    // Soulmate Analysis
    "soulmate_characteristics": "आत्मा साथी विशेषताएं",
    "ideal_partner_traits": "आदर्श साझीदार गुण",
    "soulmate_timing": "आपका आत्मा साथी कब मिलेगा",
    "recognition_signs": "आत्मा साथी पहचान संकेत",
    "karmic_connections": "कार्मिक प्रेम संबंध",
    "twin_flame_indicators": "जुड़वां ज्योति संकेतक",

    // Marriage Predictions
    "marriage_timing": "विवाह समय भविष्यवाणी",
    "wedding_auspicious_dates": "शुभ विवाह तिथियां",
    "married_life_forecast": "वैवाहिक जीवन पूर्वानुमान",
    "spouse_characteristics": "जीवनसाथी विशेषताएं",
    "marriage_compatibility": "विवाह अनुकूलता स्कोर",
    "family_harmony": "पारिवारिक सद्भावना संभावनाएं",

    // Relationship Phases
    "dating_guidance": "डेटिंग चरण मार्गदर्शन",
    "courtship_period": "प्रेम काल अंतर्दृष्टि",
    "engagement_timing": "सगाई का समय",
    "pre_marriage_guidance": "विवाह पूर्व मार्गदर्शन",
    "honeymoon_phase": "हनीमून चरण भविष्यवाणी",
    "long_term_relationship": "दीर्घकालिक रिश्ते का पूर्वानुमान",

    // Love Challenges & Solutions
    "relationship_challenges": "संभावित रिश्ते की चुनौतियां",
    "compatibility_issues": "संबोधित करने वाले अनुकूलता मुद्दे",
    "communication_style": "संचार शैली मैच",
    "conflict_resolution": "संघर्ष समाधान मार्गदर्शन",
    "trust_building": "विश्वास निर्माण रणनीतियां",
    "intimacy_enhancement": "अंतरंगता वृद्धि सुझाव",

    // Romantic Timing
    "love_favorable_periods": "प्रेम अनुकूल अवधि",
    "romantic_peak_times": "रोमांटिक चरम समय",
    "proposal_timing": "सर्वोत्तम प्रस्ताव समय",
    "relationship_milestones": "रिश्ते के मील के पत्थर का समय",
    "anniversary_significance": "वर्षगांठ महत्व",
    "renewal_periods": "रिश्ते नवीनीकरण अवधि",

    // Venus Analysis
    "venus_sign_influence": "शुक्र राशि प्रभाव",
    "venus_house_position": "शुक्र भाव स्थिति",
    "venus_aspects": "शुक्र ग्रहीय दृष्टि",
    "venus_dignity": "शुक्र शक्ति और गरिमा",
    "venus_remedies": "शुक्र वृद्धि उपाय",
    "venus_mantras": "शुक्र प्रेम मंत्र",

    // Love Types & Styles
    "passionate_love": "भावुक प्रेम संकेतक",
    "companionate_love": "साहचर्य प्रेम शैली",
    "romantic_love": "रोमांटिक प्रेम अभिव्यक्ति",
    "unconditional_love": "निःशर्त प्रेम क्षमता",
    "spiritual_love": "आध्यात्मिक प्रेम संबंध",
    "platonic_relationships": "प्लेटोनिक रिश्ते अंतर्दृष्टि",

    // Compatibility Factors
    "mental_compatibility": "मानसिक अनुकूलता",
    "emotional_compatibility": "भावनात्मक अनुकूलता",
    "physical_compatibility": "शारीरिक अनुकूलता",
    "spiritual_compatibility": "आध्यात्मिक अनुकूलता",
    "lifestyle_compatibility": "जीवनशैली अनुकूलता",
    "financial_compatibility": "विवाह में वित्तीय अनुकूलता",

    // Love Remedies
    "love_enhancing_remedies": "प्रेम वृद्धि उपाय",
    "relationship_healing": "रिश्ते उपचार प्रथाएं",
    "attraction_remedies": "आकर्षण वृद्धि उपाय",
    "marriage_delay_remedies": "विवाह विलंब उपाय",
    "love_gemstones": "प्रेम और रिश्ते रत्न",
    "romantic_rituals": "रोमांटिक अनुष्ठान और प्रथाएं",

    // Past Life & Karma
    "past_life_love_connections": "पूर्व जन्म प्रेम संबंध",
    "karmic_relationships": "कार्मिक रिश्ते पैटर्न",
    "soul_contracts": "प्रेम में आत्मा अनुबंध",
    "karmic_debt_love": "रिश्तों में कार्मिक ऋण",
    "spiritual_lessons_love": "प्रेम के माध्यम से आध्यात्मिक सबक",
    "past_life_spouse": "पूर्व जन्म जीवनसाथी संबंध",

    // Love Forecast
    "monthly_love_forecast": "मासिक प्रेम पूर्वानुमान",
    "yearly_romance_predictions": "वार्षिक रोमांस भविष्यवाणी",
    "love_life_phases": "प्रेम जीवन चरण",
    "relationship_cycles": "रिश्ते चक्र",
    "romantic_opportunities": "आगे रोमांटिक अवसर",
    "love_life_transformation": "प्रेम जीवन परिवर्तन अवधि",

    // Special Love Scenarios
    "second_marriage": "दूसरे विवाह की संभावनाएं",
    "late_marriage": "देर से विवाह भविष्यवाणी",
    "love_marriage_vs_arranged": "प्रेम विवाह बनाम व्यवस्थित विवाह",
    "intercaste_marriage": "अंतरजातीय विवाह संभावनाएं",
    "foreign_spouse": "विदेशी जीवनसाथी संभावनाएं",
    "celebrity_romance": "उच्च प्रोफ़ाइल रोमांस संकेतक",

    // Relationship Counseling
    "pre_marital_counseling": "विवाह पूर्व ज्योतिषीय परामर्श",
    "relationship_therapy": "ज्योतिषीय रिश्ते थेरेपी",
    "couple_compatibility": "जोड़े अनुकूलता वृद्धि",
    "marriage_counseling": "विवाह परामर्श अंतर्दृष्टि",
    "relationship_revival": "रिश्ते पुनरुद्धार मार्गदर्शन",
    "love_life_coaching": "प्रेम जीवन कोचिंग",

    // Advanced Love Analysis
    "composite_chart_analysis": "कंपोजिट चार्ट विश्लेषण",
    "synastry_compatibility": "सिनास्ट्री अनुकूलता रीडिंग",
    "davison_relationship_chart": "डेविसन रिश्ते चार्ट",
    "progressed_love_indicators": "प्रगतिशील प्रेम संकेतक",
    "solar_return_love": "सूर्य वापसी प्रेम भविष्यवाणी",
    "lunar_return_romance": "चांद्र वापसी रोमांस अंतर्दृष्टि"
};
